import styled from 'styled-components'

export const MenuContainer = styled.div`

  .menu-mobile{
    .menu-title{
        color: #8F9BB3; 
        font-size: 15px;
        font-weight: 600;
        margin: 20px 0 0px 0px;
        padding: 0 0 20px 16px; 
        border-bottom: 1px solid #EDF1F7;
    }

    .ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after, .ant-menu-inline .ant-menu-item::after {
        border-right: unset !important;
    }

    .ant-menu-sub.ant-menu-inline, .ant-menu-sub.ant-menu-inline:hover,.ant-menu-submenu-title:hover,.ant-menu-submenu-selected, .ant-menu-light .ant-menu-submenu-title:hover, .ant-menu-item:active {
      background-color: white!important;
      color:#222B45!important;
    }

    .ant-menu-item a, .ant-menu-title-content a:hover{
      background-color: white!important;
      color:#7A808F!important;
    }

    .ant-menu-submenu-title, .ant-menu-inline.ant-menu-root .ant-menu-item{
      border-bottom: 1px solid #EDF1F7!important;
    }

    .ant-menu-submenu-title, .ant-menu-item{
      height: 63px;
    }

    .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
      background-color: white;
      font-weight: 600;
    }

  }

  .menu-desktop {
    @media (max-width: 767px){
      display: none;
    }
    width: 35%;
    background-color: rgba(51,102,255, .08);
    height: 100vh;
    padding-left: calc(35% - 0.35*768px);
    padding-top: 88px;
    direction: rtl;
    overflow: auto;
    position: fixed;
    
    .menu-title{
        direction: ltr;
        color: #8F9BB3; 
        font-size: 15px;
        font-weight: 600;
        padding: 20px 0 20px 16px; 
        border-bottom: 1px solid rgba(51,102,255, .10);
    }

    .ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after, .ant-menu-inline .ant-menu-item::after {
        border-right: unset !important;
    }

    .ant-menu-sub.ant-menu-inline, .ant-menu-sub.ant-menu-inline:hover,.ant-menu-submenu-title:hover,.ant-menu-submenu-title,.ant-menu-submenu-selected,.ant-menu-submenu, .ant-menu-light .ant-menu-submenu-title:hover, .ant-menu-submenu-title, .ant-menu-item:active, .ant-menu-item {
      background-color: transparent!important;
      color:#222B45!important;
    }

    .ant-menu-item a, .ant-menu-title-content a:hover{
      background-color: transparent!important;
      color:#7A808F!important;
    }

    .ant-menu-submenu-title, .ant-menu-inline.ant-menu-root .ant-menu-item{
      border-bottom: 1px solid rgba(51,102,255, .10);
    }

    .ant-menu-root.ant-menu-inline{
      background-color: transparent;
    }

    .ant-menu-inline.ant-menu-root .ant-menu-item {
      padding-left: 24px!important;
    }

    .ant-menu-submenu-title, .ant-menu-item{
      height: 63px;
    }
  }
`

